import React from 'react';
import OddsButton from '../../../../OddsButton/OddsButton';

const Empty = ({ column }) => {
    return (
        <tr>
            {column === 2 ? (
                <>
                    <td>
                        <OddsButton isNull />
                    </td>
                    <td>
                        <OddsButton isNull />
                    </td>
                </>
            ) : (
                <>
                    <td>
                        <OddsButton isNull />
                    </td>
                    <td>
                        <OddsButton isNull />
                    </td>
                    <td>
                        <OddsButton isNull />
                    </td>
                </>
            )}
        </tr>
    );
};

export default Empty;
